import React from 'react';
import { Toolbar, InputBase, IconButton, Box, useTheme, useMediaQuery } from '@mui/material';
import { Search, FilterList, FilterListOff } from '@mui/icons-material';
import useDialogHook from 'hooks/useDialogHook';
import FilterDialog from 'layouts/production/Pages/All/SearchBar/filterDialog';
import { useSearch } from 'layouts/production/Pages/SearchProvider';

// Production colors from palette
const colors = {
    primary: '#e91e63', // Primary - Pink
    secondary: '#7b809a', // Secondary
    dark: '#344767', // Dark
    darkGradient: '#191919', // Dark Gradient end
    light: '#f0f2f5', // Light
    lightNeutral100: '#f8f9fa', // Light Neutral 100
    lightNeutral300: '#dee2e6', // Light Neutral 300
    lightNeutral500: '#adb5bd', // Light Neutral 500
    lightNeutral600: '#6c757d', // Light Neutral 600
    lightNeutral900: '#212529', // Light Neutral 900
    success: '#4CAF50', // Success
    white: '#ffffff',
};

function AdvancedSearch() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // Use the useDialogHook to handle opening and closing of the FilterDialog
    const { open, handleClickOpen, handleClose } = useDialogHook();

    // Destructure the required properties and methods from useSearch
    const {
        searchProductionQuery: searchQuery,
        updateSearchProductionQuery: updateSearchQuery,
        resetFilters,
    } = useSearch();

    return (
        // Box container with dark background using the dark color from palette
        <Box
            sx={{
                borderRadius: 1,
            }}
        >
            <Toolbar
                disableGutters
                variant="dense"
                sx={[{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    width: '100%',
                    minHeight: '48px',
                    px: 0.5,
                    py: 0.75,
                    backgroundColor: 'transparent'
                }, isMobile ? {
                    flexDirection: 'column'
                } : {
                    flexDirection: 'row'
                }]}
            >
                {/* Search Input Section */}
                <Box
                    sx={[{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        backgroundColor: colors.light,
                        borderRadius: 1.5,
                        border: `1px solid ${"var(--colors-lightNeutral300)"}`,
                        p: '4px 8px'
                    }, isMobile ? {
                        width: '100%'
                    } : {
                        width: 'auto'
                    }]}
                    style={{
                        "--colors-lightNeutral300": colors.lightNeutral300
                    }}>
                    <IconButton sx={{ p: '6px', color: colors.lightNeutral600 }} aria-label="search">
                        <Search fontSize="small" />
                    </IconButton>
                    <InputBase
                        sx={{
                            ml: 1,
                            flex: 1,
                            color: colors.lightNeutral900,
                            fontSize: '0.9rem',
                            '& ::placeholder': {
                                color: colors.lightNeutral500,
                                opacity: 1,
                            },
                        }}
                        placeholder="Üretimlerde ve Müşterilerde Ara..."
                        value={searchQuery}
                        onChange={(e) => updateSearchQuery(e.target.value)}
                        inputProps={{ 'aria-label': 'üretimlerde ve müşterilerde ara' }}
                    />
                </Box>

                {/* Action Buttons Section */}
                <Box
                    sx={[{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }, isMobile ? {
                        width: '100%'
                    } : {
                        width: 'auto'
                    }, isMobile ? {
                        justifyContent: 'space-between'
                    } : {
                        justifyContent: 'flex-end'
                    }]}
                >
                    <IconButton
                        onClick={resetFilters}
                        size="small"
                        sx={{ color: colors.lightNeutral100 }}
                        title="Filtreleri Temizle"
                    >
                        <FilterListOff fontSize="small" />
                    </IconButton>

                    <IconButton
                        onClick={handleClickOpen}
                        size="small"
                        sx={{ color: colors.lightNeutral100 }}
                        title="Filtrele"
                    >
                        <FilterList fontSize="small" />
                    </IconButton>
                </Box>
            </Toolbar>
            {/* Dialogs */}
            {open && <FilterDialog open={open} handleClose={handleClose} />}
        </Box>
    );
}

export default AdvancedSearch;
